import React from "react";
import { Menu } from "semantic-ui-react";
import "../../styles/ui.scss";

const BCActionMenu = ({ ...props }) => {
  return (
    <div>
      <Menu className="action-menu" secondary>
        {props.actions.map((action, i) => {
          return (
            <Menu.Item
              key={"action" + i}
              name={action.name}
              onClick={() => action.event(action.name)}
            />
          );
        })}
      </Menu>
    </div>
  );
};

export default BCActionMenu;